
import { IUnidadeGestoraModel } from "src/app/models/unidade-gestora.model";
import {
	Component,
	Inject,
	OnInit,
	AfterViewInit,
	ViewChild,
} from "@angular/core";
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogConfig,
} from "@angular/material/dialog";
import { CriterioService } from "src/app/services/criterio.service";
import Swal from "sweetalert2";
import { ICriterioModel } from "src/app/models/criterio.model";
import { IMatrizRiscoControle, IMatrizRiscoControleAtividade, IMatrizRiscoControleRisco } from "../model/matriz-risco-controle.model";
import { CriteriosAvaliacaoRiscoService } from "src/app/services/criterios-avaliacao-risco.service";
import { MrAbaRiscosComponent } from "./aba-riscos/mr-aba-riscos.component";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
import { MrAbaControleComponent } from "./aba-controle/mr-aba-controle.component";
import { MrAbaTestesComponent } from "./aba-testes/mr-aba-testes.component";
import { MatrizRiscoControleService } from "../service/matriz-risco-controle.service";
import { ModalCancelarComponent } from "src/app/shared/components/modal-cancelar/modal-cancelar-component";
import { read, utils, write } from 'xlsx-js-style';
import { MrAbaAtividadesComponent } from "./aba-atividades/mr-aba-atividades.component";
import { Controles, ImportMatrizRisco, Riscos, Testes } from "../model/import-matriz-risco.model";
import * as XLSX from 'xlsx';

@Component({
	selector: "app-modal-incluir-matriz-risco",
	templateUrl: "./modal-incluir-matriz-risco.component.html",
	styleUrls: ["./modal-incluir-matriz-risco.component.scss"],
})

export class IncluirMatrizRiscoComponent extends BaseListComponent implements OnInit, AfterViewInit {
	visualizar: boolean;
	importar: boolean;
	editar: boolean;
	titulo: string;
	numeroOpa: string;
	planejamentoId: number;
	idUnidade: number;
	id: number;
	aba!: number;

	unidadesGetoras: IUnidadeGestoraModel[];
	listCriterios!: ICriterioModel[];
	nomeProcesso!: string;

	dadosBrutos: any[] = [];
	arquivoDados!: Array<Array<string>>;

	objPrincipal: IMatrizRiscoControle = {} as IMatrizRiscoControle;

	logsMatrizRisco: Array<{ id: any, erro: any, objeto: any }> = [];

	@ViewChild(MrAbaAtividadesComponent) abaAtividade!: MrAbaAtividadesComponent;
	@ViewChild(MrAbaRiscosComponent) abaRisco!: MrAbaRiscosComponent;
	@ViewChild(MrAbaControleComponent) abaControle!: MrAbaControleComponent;
	@ViewChild(MrAbaTestesComponent) abaTeste!: MrAbaTestesComponent;

	// Importação 
	private atividadeId = 1;
	private riscoId = 1;
	private controleId = 1;
	private testeId = 1;

	atividades: ImportMatrizRisco[] = [];
	riscos: Riscos[] = [];
	controles: Controles[] = [];
	testes: Testes[] = [];
	//=====================

	constructor(
		private criterioService: CriteriosAvaliacaoRiscoService,
		public matDialog: MatDialog,
		private dialogRef: MatDialogRef<IncluirMatrizRiscoComponent>,
		@Inject(MAT_DIALOG_DATA) public data,
		private matrizControleService: MatrizRiscoControleService
	) {
		super();
		this.unidadesGetoras = data?.dadosPlanejamento.planejamentoUgSubtipo;
		this.visualizar = data?.visualizar;
		this.importar = data?.importar;
		this.titulo = data?.titulo;
		this.editar = data?.titulo === "Editar";
		this.numeroOpa = data?.numeroOpa;
		this.planejamentoId = data?.dadosPlanejamento.id;
		this.idUnidade = data?.idUnidade;
		this.id = data?.id;
	}

	ngOnInit(): void {
		this.aba = -1;
	}

	ngAfterViewInit() {
		this.carregaCriterios();
		this.inicializaObjPrincipal();
	}

	inicializaObjPrincipal() {

		if (this.editar || this.visualizar) {
			this.carregarObjPrincipal();
		} else {
			this.objPrincipal.id = 0;
			this.objPrincipal.idCriterioAvaliacao = 0;
			this.objPrincipal.idPlanejamento = this.planejamentoId;
			this.objPrincipal.idSubTipo = 0;
			this.objPrincipal.idUnidade = 0;
			this.objPrincipal.idUnidadeSubTipo = "";

			if (this.objPrincipal.atividades == null)
				this.objPrincipal.atividades = [];

			if (this.objPrincipal.riscos == null)
				this.objPrincipal.riscos = [];

			if (this.objPrincipal.associados == null)
				this.objPrincipal.associados = [];

			if (this.objPrincipal.testes == null)
				this.objPrincipal.testes = [];

			this.objPrincipal.atividadesRemover = [];
			this.objPrincipal.riscosRemover = [];
			this.objPrincipal.associadosRemover = [];
			this.objPrincipal.testesRemover = [];
		}
	}

	downloadLogsErro(): void {
		if (!this.logsMatrizRisco || this.logsMatrizRisco.length === 0) {
			return;
		}

		const normalizaErro = (raw: any): string => {
			let s = typeof raw === 'string' ? raw : String(raw);

			// 1) Se vier como string JSON com \" tenta decodificar
			if ((s.startsWith('"') && s.endsWith('"')) || s.includes('\\"')) {
				try {
					s = JSON.parse(s);
				} catch {
					s = s.replace(/\\"/g, '"'); // fallback: só desescapa
				}
			}

			s = s.replace(/:\s*"([^"]*?)"\s*\./g, ': $1'); // com ponto logo após as aspas
			s = s.replace(/:\s*"([^"]*?)"/g, ': $1');      // sem ponto

			s = s.replace(/"\s*([+-]?\d+(?:[.,]\d+)?)\s*"/g, '$1');

			s = s.replace(/^"\s*|\s*"$/g, '');

			s = s.replace(/\s{2,}/g, ' ').trim();

			return s;
		};

		const logsFormatados = this.logsMatrizRisco.map((log: any) => ({
			sequencia: log.id,
			erro: normalizaErro(log.erro),
			objeto: log.objeto
		}));

		const dataStr = JSON.stringify(logsFormatados, null, 2);
		const dataBlob = new Blob([dataStr], { type: 'application/json' });

		// Nome do arquivo com data e hora: YYYY-MM-DD_HH-mm-ss
		const agora = new Date();
		const dataHora = agora.toISOString().replace('T', '').replace(/:/g, '').split('.')[0];

		const link = document.createElement('a');
		link.href = URL.createObjectURL(dataBlob);
		link.download = `logs-ImportacaoMatrizRisco-${dataHora}.txt`;
		document.body.appendChild(link); // melhora compatibilidade
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(link.href);

		this.logsMatrizRisco = [];
	}


	carregarObjPrincipal() {
		this.matrizControleService
			.obterPorPlanejamento(this.planejamentoId, this.idUnidade, this.id)
			.then((res) => {
				if (res.dados) {
					this.objPrincipal = res.dados[0] as IMatrizRiscoControle;

					setTimeout(() => {
						this.changeCriterios();
					}, 500);
				}
			})
			.catch((err) => {
				this.exibirMensagemErro(err.mensagem.descricao);
			});
	}


	private recalcularDescricoesDosTestes() {
		if (!this.objPrincipal.testes) return;

		this.objPrincipal.testes.forEach(teste => {
			const associado = this.objPrincipal.associados?.find(f => f.id === teste.idMatrizRiscoControleAssociados);
			const risco = associado
				? this.objPrincipal.riscos?.find(f => f.id === associado.idMatrizRiscoControleRiscos)
				: null;

			teste.descricaoRiscoVinculado = risco ? `R${risco.posicao} - ${risco.descricaoRisco}` : '';

			teste.descricaoQuestoes = teste.realizarTestes === false
				? '-'
				: (teste.questoes && teste.questoes.length > 0
					? teste.questoes.map(q => q.descricaoQuestao).join('; ')
					: '-');
		});
	}
	carregaCriterios() {
		this.criterioService
			.obter("", true, false)
			.then((res) => {
				this.listCriterios = res.dados as ICriterioModel[];
			})
			.catch((err) => {
				this.exibirMensagemErro(err.mensagem.descricao);
			})
	}

	montaObjSalvar() {
		//this.objPrincipal.id = 0;
	}

	validaSalvar() {
		const nomeProcesso = this.objPrincipal.nomeProcesso || '';

		if (nomeProcesso.length < 2 || nomeProcesso.length > 255) {
			this.exibirMensagemAlerta("Processo de trabalho auditado deve ter entre 2 e 100 caracteres!");
			return false;
		}

		return true;
	}

	public async salvar(fechar?: boolean) {
		try {
			if (this.validaSalvar() == false)
				return;

			this.montaObjSalvar();

			let res = await this.matrizControleService.inserir(this.objPrincipal);
			if (res.sucesso) {
				this.exibirMensagemSucesso("Matriz de Risco Cadastrada com Sucesso.");
			}
			else {
				this.exibirMensagemAlerta(res.mensagem.descricao);
			}

			if (fechar)
				this.dialogRef.close();
			else {
				this.editar = true;
				this.idUnidade = res.dados?.idUnidade;
				this.id = res.dados?.id;
				this.inicializaObjPrincipal();
			}
		}
		catch (err) {
			console.error('Erro ao salvar Matriz de Risco:', err); // ← temporário, para inspecionar no console
			const mensagem = err?.error?.mensagem?.descricao || err?.mensagem?.descricao || err?.message || 'Erro inesperado ao salvar.';
			this.exibirMensagemErro(mensagem);
		}
	}

	public cancelar() {
		if (this.visualizar) {
			this.dialogRef.close();
		} else {
			const dialogConfig = new MatDialogConfig();
			const modal = this.matDialog.open(ModalCancelarComponent, dialogConfig);
			modal.afterClosed().subscribe((resultado) => {
				if (resultado == true) {
					this.dialogRef.close();
				}
			});
		}
	}

	public mudarAba(ind: number) {

		if (this.abaLiberadas() == false)
			return;

		if (ind == 1) {
			if (this.objPrincipal.atividades == undefined || this.objPrincipal.atividades.length == 0) {
				this.exibirMensagemAlerta("Adicione ao menos 1 'Atividade' para acessar aba 'Riscos Identificados'");
				return;
			}

			this.abaRisco.setAtividade();
		}

		if (ind == 2) {
			if (this.objPrincipal.riscos == undefined || this.objPrincipal.riscos.length == 0) {
				this.exibirMensagemAlerta("Adicione ao menos 1 'Risco Identificado' para acessar aba 'Controles Associados'");
				return;
			}

			this.abaControle.setRisco();
		}

		if (ind == 3) {
			if (this.objPrincipal.associados == undefined || this.objPrincipal.associados.length == 0) {
				this.exibirMensagemAlerta("Adicione ao menos 1 'Controle Associado' para acessar aba 'Testes'");
				return;
			}

			this.abaTeste.setAssociado();
		}
		this.aba = ind;
	}

	changeCriterios() {
		this.abaTeste.carregaQuestoes();
		this.abaRisco.carregaEscalas();
		this.abaControle.carregaControles();
	}

	bloqueiaCampos() {
		return this.objPrincipal.atividades != undefined && this.objPrincipal.atividades.length > 0;
	}

	abaLiberadas() {
		return this.objPrincipal.idUnidadeSubTipo.toString() != "" && this.objPrincipal.idCriterioAvaliacao.toString() != "";
	}

	changeUnidade() {
		this.objPrincipal.idUnidade = Number(this.objPrincipal.idUnidadeSubTipo.split('-')[0]);
		this.objPrincipal.idSubTipo = Number(this.objPrincipal.idUnidadeSubTipo.split('-')[1]);
	}


	canImportar(): boolean {
		if (this.objPrincipal.idUnidadeSubTipo && this.objPrincipal.idCriterioAvaliacao && this.objPrincipal.nomeProcesso) {
			return true
		} else {
			return false
		}
	}

	async importarArquivo(event: any) {
		const input = event.target as HTMLInputElement;
		if (!(input.files && input.files.length > 0)) {
			return;
		}

		const file = input.files[0];
		const fileExtension = file.name.split('.').pop()?.toLowerCase();

		const maxSize = 28 * 1024 * 1024; // 28MB
		if (file.size > maxSize) {
			this.exibirMensagemAlerta("O arquivo excede o tamanho máximo de 28 MB.");
			event.target.value = '';
			return;
		}

		if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
			this.exibirMensagemAlerta("Por favor, selecione um arquivo no formato .xlsx ou .xls!");
			event.target.value = '';
			return;
		}

		this.mudarAba(0);

		const reader = new FileReader();

		reader.onload = async (e: any) => {
			try {
				const data = new Uint8Array(e.target.result);
				const workbook = XLSX.read(data, { type: 'array' });
				const sheet = workbook.Sheets[workbook.SheetNames[0]];
				const jsonData: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

				// Lê somente a linha 4 (títulos)
				const titulos: any[][] = XLSX.utils.sheet_to_json(sheet, {
					header: 1,
					range: "A5:R5",
					defval: ''
				});

				// Verifica se temos exatamente 18 colunas
				if (!titulos || titulos[0].length < 18 || titulos[0][17].toString().trim() === "") {
					this.exibirMensagemAlerta("A planilha está inválida: é obrigatório haver informações preenchidas da coluna A até a coluna R na linha 4");
					return;
				}

				const { atividades, riscos, controles, testes } = await this.processarEstrutura(jsonData);

				const cleanText = (v: any) => (v ?? '').toString().replace(/\s+/g, ' ').trim();
				const onlyDigits = (v: any) => cleanText(v).replace(/\D+/g, '');

				// Atividade
				for (const atividade of atividades ?? []) {
					this.abaAtividade.descricaoAtividade = atividade?.DescricaoAtividade.substring(0, 554) ?? '';
					this.abaAtividade.nomeResponsavel = atividade?.Responsavel ?? '';
					this.abaAtividade.descricaoRealizacao = atividade?.Como?.substring(0, 554) ?? '';
					this.abaAtividade.adicionar();
				}

				// Riscos
				for (const risco of riscos ?? []) {
					try {

						this.abaRisco.carregaEscalas();
						this.abaRisco.carregaCriteriosRiscos();
						this.abaRisco.getListEscalaMagnitude();

						this.abaRisco.controleRiscoSelecionado = risco?.Id;
						const criterio = this.abaRisco?.listCriteriosRiscos?.find((o: any) => o?.nome?.trim() === (risco?.DescricaoRisco ?? '').trim());

						if (!criterio) {
							this.abaRisco.novoRisco();
							this.abaRisco.txtDescricaoRisco = risco?.DescricaoRisco ?? '';
						} else {
							this.abaRisco.riscoSelecionado = criterio.id;
							this.abaRisco.changeRisco();
						}

						// Impacto
						const impVal = onlyDigits?.(risco?.ImpactoRisco) ?? 0;
						const idImpacto = this.abaRisco?.listEscalas?.[0]?.listMagnitude?.find((o: any) => o?.valor == impVal);
						if (idImpacto) {
							this.abaRisco.listEscalas[0].idMagnitudeSelecionado = String(idImpacto.id);
						} else {
						}

						// Probabilidade
						const probVal = onlyDigits?.(risco?.ProbabilidadeRisco) ?? 0;
						const idProb = this.abaRisco?.listEscalas?.[1]?.listMagnitude?.find((o: any) => o?.valor == probVal);
						if (idProb) {
							this.abaRisco.listEscalas[1].idMagnitudeSelecionado = String(idProb.id);
						} else {
						}

						try {
							this.abaRisco.calculaRisco();
						} catch (error) {
							this.logsMatrizRisco.push({
								id: risco?.Id,
								erro: `Erro ao calcular Risco: " ${risco?.DescricaoRisco} | Impacto: ${risco?.ImpactoRisco} | Probabilidade: ${risco?.ProbabilidadeRisco}".`,
								objeto: 'Risco'
							});
						}

						for (const c of (risco?.CausaRisco ?? [])) {
							try { this.abaRisco.txtCausa = c; this.abaRisco.addCausa(); } catch (e) {
								this.logsMatrizRisco.push({
									id: risco?.Id,
									erro: `Não foi possível adiciona causa para o Risco: "${risco?.DescricaoRisco}".`,
									objeto: 'Causa'
								});
							}
						}
						for (const c of (risco?.ConsequenciaRisco ?? [])) {
							try { this.abaRisco.txtConsequencia = c; this.abaRisco.addConsequencia(); } catch (e) {
								this.logsMatrizRisco.push({
									id: risco?.Id,
									erro: `Não foi possível adiciona consequência para o Risco: "${risco?.DescricaoRisco}".`,
									objeto: 'Consequência'
								});
							}
						}

						this.abaRisco.atividadeSelecionada = risco?.AtividadeId;

						try {
							const listRiscos = this.abaRisco.importar(risco?.Id);
							let hasData = listRiscos?.find((f: any) => f?.controle === risco?.Id);
							if (!hasData) {
								this.logsMatrizRisco.push({
									id: risco?.Id,
									erro: `Não foi possível importar Risco: " ${risco?.DescricaoRisco} | Impacto: ${risco?.ImpactoRisco} | Probabilidade: ${risco?.ProbabilidadeRisco}". Risco não adicionado.`,
									objeto: 'Risco'
								});
								this.abaRisco.limpar();
							}
						} catch (error) {
							this.abaRisco.limpar();
						}
					} catch (error) {

					}
				}

				// Controles
				if (!this.abaControle?.listAvaliacaoControle) {
					this.abaControle?.carregaControles();
				}

				for (const ctrl of controles) {
					try {

						this.abaControle.riscoSelecionado = ctrl?.RiscoId;
						this.abaControle.txtDescricaoControle = ctrl?.DescricaoControle ?? '';

						const avaliacao = this.abaControle?.listAvaliacaoControle?.find((o: any) => o?.avaliacao === ctrl?.AvaliacaoControle.trim());
						if (avaliacao) {
							this.abaControle.avaliacaoControleSelecionada = avaliacao.id;
							this.abaControle.changeAvaliacao();
						} else {
							this.logsMatrizRisco.push({
								id: ctrl?.Id,
								erro: `Não foi possível importar Controle: " ${ctrl?.DescricaoControle} - Avaliação Controle não encontrada! ${ctrl?.AvaliacaoControle}".`,
								objeto: 'Controle'
							});
						}

						this.abaControle.txtMelhorPratica = ctrl?.MelhorPratica;

						const listControles = this.abaControle.importar(ctrl?.Id);
						let hasData = listControles?.find((f: any) => f?.controle === ctrl?.Id);
						if (!hasData) {
							this.logsMatrizRisco.push({
								id: ctrl?.Id,
								erro: `Não foi possível importar Controle: " ${ctrl?.DescricaoControle}". Controle não adicionado.`,
								objeto: 'Controle'
							});
						}

					} catch (error) {
					}

				}

				// Testes
				for (const teste of testes) {
					try {
						this.abaTeste.associadoSelecionado = teste?.ControleId;
						this.abaTeste.changeControle();

						try {
							const lista = this.abaTeste?.listQuestoesGeral ?? [];
							if (lista.length > 0) {
								const questaoTeste = teste?.QuestaoTeste || '';
								const textoSemPrefixo = questaoTeste.replace(/^Q\.\d+:\s*/i, '');
								const q = lista.find((o: any) =>
									o?.nome === questaoTeste ||
									o?.nome === textoSemPrefixo ||
									`Q.${o?.ordem?.toString().padStart(2, '0')}: ${o?.nome}` === questaoTeste
								);
								if (q) {
									this.abaTeste.questaoSelecionada = q.id;
									this.abaTeste.addQuestao();
								} else {
									this.logsMatrizRisco.push({
										id: teste?.Id,
										erro: `Não foi possível importar teste, questão "${teste?.QuestaoTeste}" não encontrada!`,
										objeto: 'Teste'
									});
								}
							}

							const listTestes = this.abaTeste.importar(teste?.Id);
							let hasData = listTestes?.find((f: any) => f?.posicao === teste?.Id);
							if (!hasData) {
								this.logsMatrizRisco.push({
									id: teste?.Id,
									erro: `Não foi possível importar Teste: "${teste?.QuestaoTeste}".`,
									objeto: 'Teste'
								});
							}
						} catch (e) { }

					} catch (error) {

					}
				}

				if (this.logsMatrizRisco.length > 0) {
					this.exibirMensagemAlerta("Importação concluída com erros, verifique log de importação!");
					this.downloadLogsErro();
				} else {
					this.exibirMensagemSucesso("Importação concluída com sucesso!");
				}

			} catch (error) {
				console.error("Erro ao processar:", error);
			}
		};

		reader.readAsArrayBuffer(file);
	}


	// Helper para quebrar string em array (separador ; ou quebra de linha)
	private toArray(value: any): string[] {
		if (!value) return [];
		if (typeof value === 'string') {
			return value
				.split(/[\n;]/)
				.map(v => v.trim())
				.filter(v => v.length > 0);
		}
		return [String(value)];
	}

	cleanText(text?: string): string {
		if (!text) return "";
		return text
			.replace(/(\r\n|\n|\r)/g, ' ')    // remove quebras de linha, troca por espaço
			.replace(/\s{2,}/g, ' ')          // reduz espaços múltiplos para um só
			.trim();                          // remove espaços do início/fim
	}


	private async processarEstrutura(jsonData: any[][]): Promise<{
		atividades: ImportMatrizRisco[],
		riscos: Riscos[],
		controles: Controles[],
		testes: Testes[]
	}> {
		return new Promise((resolve) => {
			let atividadeId = 1;
			let riscoId = 1;
			let controleId = 1;
			let testeId = 1;

			const atividades: ImportMatrizRisco[] = [];
			const riscos: Riscos[] = [];
			const controles: Controles[] = [];
			const testes: Testes[] = [];

			let atividadeAtual: ImportMatrizRisco | null = null;
			let riscoAtual: Riscos | null = null;
			let controleAtual: Controles | null = null;

			for (let rowIndex = 5; rowIndex < jsonData.length; rowIndex++) {
				const row = jsonData[rowIndex];
				if (!row || row.length === 0) continue;

				const refAtividade = row[0];
				const descAtividade = row[1];
				const responsavel = row[2];
				const como = row[3];
				const descRisco = row[4];
				const causa = row[5];
				const consequencia = row[6];
				const impacto = row[7];
				const probabilidade = row[8];
				const nivelRisco = row[9];
				const descControle = row[10];
				const avaliacaoControle = row[11];
				const riscoControle = row[12];
				const riscoResidual = row[13];
				const melhorPratica = row[14] ? row[14].toString().substring(0, 255) : '';
				const prioridade = row[15];
				const tipoTeste = row[16];
				const questao = row[17];

				// Nova Atividade
				if (refAtividade) {
					atividadeAtual = {
						Id: atividadeId++,
						RefAtividade: refAtividade || '',
						DescricaoAtividade: descAtividade || '',
						Responsavel: responsavel || '',
						Como: como || ''
					};
					atividades.push(atividadeAtual);
				}

				// Novo Risco
				if (descRisco) {
					riscoAtual = {
						Id: riscoId++,
						AtividadeId: atividadeAtual ? atividadeAtual.Id : 0,
						DescricaoRisco: descRisco || '',
						CausaRisco: [],
						ConsequenciaRisco: [],
						ImpactoRisco: impacto || '',
						ProbabilidadeRisco: probabilidade || '',
						NivelRiscoInerente: nivelRisco || ''
					};
					riscos.push(riscoAtual);
				}

				if (causa && riscoAtual) riscoAtual.CausaRisco.push(causa);
				if (consequencia && riscoAtual) riscoAtual.ConsequenciaRisco.push(consequencia);

				// Novo Controle
				if (descControle && riscoAtual) {
					controleAtual = {
						Id: controleId++,
						RiscoId: riscoAtual.Id,
						DescricaoControle: descControle || '',
						AvaliacaoControle: avaliacaoControle || '',
						RiscoControle: riscoControle || '',
						RiscoResidual: riscoResidual || '',
						MelhorPratica: melhorPratica || ''
					};
					controles.push(controleAtual);
				}

				// Novo Teste
				if (questao && controleAtual) {
					const teste: Testes = {
						Id: testeId++,
						ControleId: controleAtual.Id,
						PrioridadeTeste: prioridade || '',
						TipoTeste: tipoTeste || '',
						QuestaoTeste: questao || ''
					};
					testes.push(teste);
				}
			}

			resolve({ atividades, riscos, controles, testes });
		});
	}


}
